// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Generic_Rep = require("../Data.Argonaut.Decode.Generic.Rep/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Generic_Rep = require("../Data.Argonaut.Encode.Generic.Rep/index.js");
var Data_Compactable = require("../Data.Compactable/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Lens_Index = require("../Data.Lens.Index/index.js");
var Data_Lens_Internal_Market = require("../Data.Lens.Internal.Market/index.js");
var Data_Lens_Internal_Wander = require("../Data.Lens.Internal.Wander/index.js");
var Data_Lens_Lens = require("../Data.Lens.Lens/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Editor_Class_Depends = require("../Lunarbox.Data.Editor.Class.Depends/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Lunarbox_Data_Functor = require("../Lunarbox.Data.Functor/index.js");
var Lunarbox_Data_Graph = require("../Lunarbox.Data.Graph/index.js");
var Lunarbox_Data_Lens = require("../Lunarbox.Data.Lens/index.js");
var InputNode = (function () {
    function InputNode() {

    };
    InputNode.value = new InputNode();
    return InputNode;
})();
var ComplexNode = (function () {
    function ComplexNode(value0) {
        this.value0 = value0;
    };
    ComplexNode.create = function (value0) {
        return new ComplexNode(value0);
    };
    return ComplexNode;
})();
var OutputNode = (function () {
    function OutputNode(value0) {
        this.value0 = value0;
    };
    OutputNode.create = function (value0) {
        return new OutputNode(value0);
    };
    return OutputNode;
})();
var showNode = new Data_Show.Show(function (v) {
    if (v instanceof InputNode) {
        return "InputNode";
    };
    if (v instanceof OutputNode) {
        return "Output " + Data_Maybe.maybe("???")(Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(v.value0);
    };
    if (v instanceof ComplexNode) {
        return Data_Show.show(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
            return "function";
        }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
            return "inputs";
        }))(Data_Show.showRecordFieldsNil)(Data_List_Types.showList(Data_Maybe.showMaybe(Lunarbox_Data_Editor_Node_NodeId.showNodeId))))(Lunarbox_Data_Editor_FunctionName.showFunctionName)))(v.value0);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 67, column 1 - line 70, column 40): " + [ v.constructor.name ]);
});
var makePinExpression = function (node) {
    return function (index) {
        var location = Lunarbox_Data_Editor_Node_PinLocation.PinLocation.create(node)(new Lunarbox_Data_Editor_Node_PinLocation.InputPin(index));
        return function (v) {
            if (v instanceof Data_Maybe.Just) {
                return Lunarbox_Data_Dataflow_Expression.Variable.create(location)(Lunarbox_Data_Dataflow_Expression.VarName(Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value0)));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return new Lunarbox_Data_Dataflow_Expression.TypedHole(location);
            };
            throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 145, column 32 - line 147, column 32): " + [ v.constructor.name ]);
        };
    };
};
var getInputs = function (v) {
    if (v instanceof ComplexNode) {
        return v.value0.inputs;
    };
    if (v instanceof OutputNode) {
        return Control_Applicative.pure(Data_List_Types.applicativeList)(v.value0);
    };
    if (v instanceof InputNode) {
        return Data_List_Types.Nil.value;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 90, column 13 - line 93, column 19): " + [ v.constructor.name ]);
};
var getFunctionName = function (v) {
    if (v instanceof ComplexNode) {
        return v["value0"]["function"];
    };
    if (v instanceof InputNode) {
        return "input";
    };
    if (v instanceof OutputNode) {
        return "output";
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 83, column 19 - line 86, column 40): " + [ v.constructor.name ]);
};
var genericNode = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof InputNode) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof ComplexNode) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof OutputNode) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 59, column 1 - line 59, column 46): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return InputNode.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new ComplexNode(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
        return new OutputNode(x.value0.value0);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 59, column 1 - line 59, column 46): " + [ x.constructor.name ]);
});
var functionCall = function (location) {
    return function (calee) {
        return function (id) {
            var $80 = Lunarbox_Data_Dataflow_Expression.Expression.create(location);
            var $81 = Data_FoldableWithIndex.foldlWithIndex(Data_List_Types.foldableWithIndexList)((function () {
                var $83 = Lunarbox_Data_Editor_Node_PinLocation.AtApplication.create(id);
                return function ($84) {
                    return Lunarbox_Data_Dataflow_Expression.FunctionCall.create($83($84));
                };
            })())(calee);
            return function ($82) {
                return $80($81($82));
            };
        };
    };
};
var eqNode = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof InputNode && y instanceof InputNode) {
            return true;
        };
        if (x instanceof ComplexNode && y instanceof ComplexNode) {
            return Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(x["value0"]["function"])(y["value0"]["function"]) && Data_Eq.eq(Data_List_Types.eqList(Data_Maybe.eqMaybe(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)))(x.value0.inputs)(y.value0.inputs);
        };
        if (x instanceof OutputNode && y instanceof OutputNode) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Lunarbox_Data_Editor_Node_NodeId.eqNodeId))(x.value0)(y.value0);
        };
        return false;
    };
});
var encodeJsonNode = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic_Rep.genericEncodeJson(genericNode)(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "InputNode";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "ComplexNode";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonList(Data_Argonaut_Encode_Class.encodeJsonMaybe(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId)))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "inputs";
}))())(new Data_Symbol.IsSymbol(function () {
    return "function";
}))())())))(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "OutputNode";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonMaybe(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId)))))));
var dependsNode = new Lunarbox_Data_Editor_Class_Depends.Depends(function (v) {
    if (v instanceof OutputNode && v.value0 instanceof Data_Maybe.Just) {
        return Data_Set.singleton(v.value0.value0);
    };
    if (v instanceof ComplexNode) {
        return Data_Set.fromFoldable(Data_List_Types.foldableList)(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(Data_Compactable.compact(Data_Compactable.compactableList)(v.value0.inputs));
    };
    return Data_Monoid.mempty(Data_Set.monoidSet(Lunarbox_Data_Editor_Node_NodeId.ordNodeId));
});
var decodeJsonNode = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic_Rep.genericDecodeJson(genericNode)(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "InputNode";
})))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "ComplexNode";
}))(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeList(Data_Argonaut_Decode_Class.decodeJsonMaybe(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "inputs";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "function";
}))()())()))(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "OutputNode";
}))(Data_Argonaut_Decode_Class.decodeJsonMaybe(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId))))));
var connectedInputs = (function () {
    var $85 = Data_Functor.map(Data_List_Types.functorList)(Data_Tuple.uncurry((function () {
        var $88 = Data_Functor.map(Data_Maybe.functorMaybe);
        return function ($89) {
            return $88(Data_Tuple.Tuple.create($89));
        };
    })()));
    var $86 = Lunarbox_Data_Functor.indexed(Data_List_Types.functorWithIndexList);
    return function ($87) {
        return Data_List.catMaybes($85($86(getInputs($87))));
    };
})();
var compileNode = function (nodes) {
    return function (id) {
        return function (child) {
            return Data_Function.flip(Data_Maybe.maybe(Lunarbox_Data_Dataflow_Expression.TypedHole.create(new Lunarbox_Data_Editor_Node_PinLocation.UnexistingNode(id))))(Lunarbox_Data_Graph.lookup(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(id)(nodes))(function (v) {
                if (v instanceof InputNode) {
                    return Lunarbox_Data_Editor_Node_PinLocation.inputNode(id)(child);
                };
                if (v instanceof OutputNode) {
                    var location = Lunarbox_Data_Editor_Node_PinLocation.PinLocation.create(id)(new Lunarbox_Data_Editor_Node_PinLocation.InputPin(1));
                    return Lunarbox_Data_Editor_Node_PinLocation.outputNode(id)((function () {
                        if (v.value0 instanceof Data_Maybe.Just) {
                            return Lunarbox_Data_Dataflow_Expression.Variable.create(location)(Lunarbox_Data_Dataflow_Expression.VarName(Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value0.value0)));
                        };
                        if (v.value0 instanceof Data_Maybe.Nothing) {
                            return new Lunarbox_Data_Dataflow_Expression.TypedHole(location);
                        };
                        throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 109, column 21 - line 111, column 38): " + [ v.value0.constructor.name ]);
                    })());
                };
                if (v instanceof ComplexNode && (v.value0.inputs instanceof Data_List_Types.Cons && (v.value0.inputs.value1 instanceof Data_List_Types.Cons && (v.value0.inputs.value1.value1 instanceof Data_List_Types.Cons && (v.value0.inputs.value1.value1.value1 instanceof Data_List_Types.Nil && v["value0"]["function"] === "if"))))) {
                    var name = Lunarbox_Data_Dataflow_Expression.VarName(Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(id));
                    var mkExpr = makePinExpression(id);
                    var thenExpr = mkExpr(1)(v.value0.inputs.value1.value0);
                    var elseExpr = mkExpr(2)(v.value0.inputs.value1.value1.value0);
                    var condExpr = mkExpr(0)(v.value0.inputs.value0);
                    var value = Lunarbox_Data_Dataflow_Expression.Expression.create(new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(id))(new Lunarbox_Data_Dataflow_Expression.If(new Lunarbox_Data_Editor_Node_PinLocation.PinLocation(id, Lunarbox_Data_Editor_Node_PinLocation.OutputPin.value), condExpr, thenExpr, elseExpr));
                    return new Lunarbox_Data_Dataflow_Expression.Let(new Lunarbox_Data_Editor_Node_PinLocation.NodeDefinition(id), name, value, child);
                };
                if (v instanceof ComplexNode) {
                    var name = Lunarbox_Data_Dataflow_Expression.VarName(Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(id));
                    var calee = Lunarbox_Data_Dataflow_Expression.Variable.create(new Lunarbox_Data_Editor_Node_PinLocation.FunctionUsage(id, v["value0"]["function"]))(Lunarbox_Data_Dataflow_Expression.VarName(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v["value0"]["function"])));
                    var $$arguments = Data_List.mapWithIndex(makePinExpression(id))(v.value0.inputs);
                    var value = Lunarbox_Data_Dataflow_Expression.Expression.create(new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(id))(functionCall(new Lunarbox_Data_Editor_Node_PinLocation.PinLocation(id, Lunarbox_Data_Editor_Node_PinLocation.OutputPin.value))(calee)(id)($$arguments));
                    return new Lunarbox_Data_Dataflow_Expression.Let(new Lunarbox_Data_Editor_Node_PinLocation.NodeDefinition(id), name, value, child);
                };
                throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 106, column 68 - line 141, column 104): " + [ v.constructor.name ]);
            });
        };
    };
};
var _OutputNode = function (dictChoice) {
    return Data_Lens_Prism["prism'"](OutputNode.create)(function (v) {
        if (v instanceof OutputNode) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
var hasOutput = (function () {
    var $90 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
    var $91 = Data_Lens_Prism.is(Data_HeytingAlgebra.heytingAlgebraBoolean)(_OutputNode(Data_Lens_Internal_Market.choiceMarket));
    return function ($92) {
        return $90($91($92));
    };
})();
var _ComplexNode = function (dictChoice) {
    return Data_Lens_Prism["prism'"](ComplexNode.create)(function (v) {
        if (v instanceof ComplexNode) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
var _ComplexNodeFunction = function (dictWander) {
    var $93 = _ComplexNode(dictWander.Choice1());
    var $94 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "function";
    }))()()(Data_Symbol.SProxy.value)(dictWander.Strong0());
    return function ($95) {
        return $93($94($95));
    };
};
var _ComplexNodeInputs = function (dictWander) {
    var $96 = _ComplexNode(dictWander.Choice1());
    var $97 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "inputs";
    }))()()(Data_Symbol.SProxy.value)(dictWander.Strong0());
    return function ($98) {
        return $96($97($98));
    };
};
var _nodeInputs = function (dictStrong) {
    return Data_Lens_Lens.lens(getInputs)(function (node) {
        if (node instanceof InputNode) {
            return Data_Function["const"](node);
        };
        if (node instanceof OutputNode) {
            var $99 = Control_Bind.join(Data_Maybe.bindMaybe);
            return function ($100) {
                return OutputNode.create($99((function (v) {
                    return Data_List.index(v)(0);
                })($100)));
            };
        };
        if (node instanceof ComplexNode) {
            return Data_Function.flip(Data_Lens_Setter.set(_ComplexNodeInputs(Data_Lens_Internal_Wander.wanderFunction)))(node);
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Editor.Node (line 172, column 27 - line 175, column 56): " + [ node.constructor.name ]);
    })(dictStrong);
};
var _nodeInput = function (index) {
    return function (dictWander) {
        var $101 = _nodeInputs(dictWander.Strong0());
        var $102 = Lunarbox_Data_Lens.listToArrayIso((dictWander.Choice1()).Profunctor0());
        var $103 = Data_Lens_Index.ix(Data_Lens_Index.indexArray)(index)(dictWander);
        return function ($104) {
            return $101($102($103($104)));
        };
    };
};
module.exports = {
    InputNode: InputNode,
    ComplexNode: ComplexNode,
    OutputNode: OutputNode,
    compileNode: compileNode,
    hasOutput: hasOutput,
    getInputs: getInputs,
    getFunctionName: getFunctionName,
    connectedInputs: connectedInputs,
    "_nodeInput": _nodeInput,
    "_ComplexNodeFunction": _ComplexNodeFunction,
    "_ComplexNodeInputs": _ComplexNodeInputs,
    "_OutputNode": _OutputNode,
    "_ComplexNode": _ComplexNode,
    "_nodeInputs": _nodeInputs,
    eqNode: eqNode,
    genericNode: genericNode,
    encodeJsonNode: encodeJsonNode,
    decodeJsonNode: decodeJsonNode,
    showNode: showNode,
    dependsNode: dependsNode
};
